module.exports = __webpack_public_path__ + "img/multiple-babies.b0f3e555.svg";